/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { List, ListItem, withStyles } from "@material-ui/core";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import footerStyle from "../../assets/jss/material-kit-react/components/footerStyle.jsx";

function Footer({ ...props }) {
  const { classes, whiteFont, about, publications, history } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const footerAvoidVh = `${classes.container} ${classes.footerExtra}`;
  return (
    <footer className={footerClasses}>
      <div className={footerAvoidVh}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a
                //href={window.language.currUrl(props.match, 'aboutus')}
                className={classes.block}
                target="_blank"
                onClick={() =>
                  history.push(window.language.currUrl(props.match, "aboutus"))
                }
              >
                {about}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                //href={window.language.currUrl(props.match, 'publications')}
                className={classes.block}
                target="_blank"
                onClick={() =>
                  history.push(
                    window.language.currUrl(props.match, "publications")
                  )
                }
              >
                {publications}
              </a>
            </ListItem>
          </List>
        </div>
        <div className={classes.right}>
          <a className={aClasses} target="_blank" />
          {"Copyright © Website Group"}
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool,
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx